<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerIdStart" />

      <div class="input-group-prepend">
        <div class="input-group-text" style="width:2rem">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerIdEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">報價單號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.QuotationNoStart" />

      <div class="input-group-prepend">
        <div class="input-group-text" style="width:2rem">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.QuotationNoEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">生效日</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.EffectiveDateStart" />

      <div class="input-group-prepend">
        <div class="input-group-text" style="width:2rem">~</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.EffectiveDateEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">有效日期</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.ValidDateStart" />

      <div class="input-group-prepend">
        <div class="input-group-text" style="width:2rem">~</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.ValidDateEnd" />
    </div>
    <div class="list-group" style="text-align: left;">
      <template v-for="(item,index) in gridData">
        <div :key="item.ItemNo" class="list-group-item list-group-item-action">
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">
              <!-- <i class="fas fa-building"></i> -->
              報價單號: {{item.QuotationNo}}
            </b>
            <!-- <h5
              class="badge badge-success"
              style="width:50%; 
              overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
     word-break: break-all;"
     Jackson錚勝，上午 09:07
資料欄位只須顯示
客戶簡稱	 
報價單號	 
報價日	 
生效日	 
有效日期	 
核准日
            >
              
            </h5>-->
          </div>
          <div>
            <h5 class="badge" style=" width:100%; text-align:left;
              overflow: hidden;">
              <span style="font-size:1rem;font-weight: 400; color:green;">
                <br />
                {{item.CustomerAbbreviation}}
              </span>
            </h5>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">報價日:{{item.QuotationDate}}</span>
            <span class="badge badge-light">生效日:{{item.EffectiveDate}}</span>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">有效日期:{{item.ValidDate}}</span>
            <span class="badge badge-light">核准日:{{item.ApproveDate}}</span>
          </div>

          <!-- <small v-if="item.Supplier" style="color:#888;float:right;">供應商: {{item.Supplier}}</small> -->
          <!-- <small style="float:right; color:#888;">
            <i class="fas fa-user"></i>
            {{form.EmployeeName}}
          </small>-->
        </div>
      </template>
    </div>

    <button @click="query" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>

<script>
export default {
  name: "QuoteInquiry",
  data: function() {
    return {
      searchData: {
        CompanyId: this.$store.state.companyId,
        CustomerIdStart: "",
        CustomerIdEnd: "",
        QuotationNoStart: "",
        QuotationNoEnd: "",
        EffectiveDateStart: null, // new Date().toISOString().slice(0, 10),
        EffectiveDateEnd: null, // new Date().toISOString().slice(0, 10),
        ValidDateStart: null, // new Date().toISOString().slice(0, 10),
        ValidDateEnd: null // new Date().toISOString().slice(0, 10)
      },
      gridData: []
    };
  },
  methods: {
    query: function() {
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/QuoteInquiry/Query", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.gridData.forEach(v => {
            let setDate = dateName => {
              if (v[dateName]) {
                var d = new Date(parseInt(v[dateName].substr(6)));
                v[dateName] =
                  d.getFullYear() +
                  "-" +
                  (d.getMonth() + 1) +
                  "-" +
                  d.getDate();
              }
            };
            setDate("QuotationDate");
            setDate("EffectiveDate");
            setDate("ValidDate");
            setDate("ApproveDate");
          });

          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    },
    back: function() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.input-group > .input-group-prepend:first-child > .input-group-text {
  width: 5.8rem;
}
input[type="date"] {
  padding: 0;
}
</style>